import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  ACTOR_TYPES,
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.authorization}roles/configurable/${COMMON_QUERY_PARAMS.ENTITY_TYPE}`;

interface RolesForSellerSummaryDto {
  roles: {
    id: string;
    name: string;
    description: string;
  }[];
  sellerName: string;
  sellerId: string;
}

export interface GetConfigurableRolesQueryPayload {
  entityId?: string;
  entityType?: string;
}

export const getConfigurableRolesRequest = ({
  entityId,
  entityType = ACTOR_TYPES.SELLER,
}: GetConfigurableRolesQueryPayload): ApiRequestDescriptor => ({
  url: buildUrl(
    ENDPOINT.replace(COMMON_QUERY_PARAMS.ENTITY_TYPE, entityType),
    { entityId },
  ),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getConfigurableRolesQuery = async (
  payload: GetConfigurableRolesQueryPayload,
): Promise<BackResponse<RolesForSellerSummaryDto[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<RolesForSellerSummaryDto[]>>(
      getConfigurableRolesRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
